import { Typography } from "../../../../core/components/molecules/Typography"

const DisciplinesEmptyState = () => {
  return (
    <div className="w-full h-fit py-4">
      <Typography className="text-mono-color-dark italic">
        Nenhum conteúdo foi encontrado.<br/>
        Reveja o tipo de conteúdo, os assuntos selecionados e os filtros aplicados.
      </Typography>
    </div>
  )
}

export default DisciplinesEmptyState;